import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface CustomerCartItem {

}

interface CustomerCartItemState {
    data: CustomerCartItem[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_FOOD_ORDER_PORT;
const URL = import.meta.env.VITE_API_FOOD_ORDER_URL;



// Diet Mapping Code
export const fetchCustomerCartItem = createAsyncThunk<CustomerCartItem[], void, { rejectValue: string }>(
    'CustomerCartItem/fetchCustomerCartItem',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: CustomerCartItem[] }>('/get_all_customer_cart_item', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createCustomerCartItem = createAsyncThunk<CustomerCartItem, any, { rejectValue: string }>(
    'CustomerCartItem/createCustomerCartItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: CustomerCartItem }>('create_customer_cart_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateCustomerCartItem = createAsyncThunk<CustomerCartItem, any, { rejectValue: string }>(
    'CustomerCartItem/updateCustomerCartItem',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: CustomerCartItem }>('update_customer_cart_item', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const CustomerCartItemSlice = createSlice({
    name: 'CustomerCartItem',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as CustomerCartItemState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchCustomerCartItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerCartItem.fulfilled, (state, action: PayloadAction<CustomerCartItem[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCustomerCartItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCustomerCartItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCustomerCartItem.fulfilled, (state, action: any) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createCustomerCartItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateCustomerCartItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCustomerCartItem.fulfilled, (state, action: PayloadAction<CustomerCartItem>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateCustomerCartItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default CustomerCartItemSlice.reducer;